import { generateSetChild, generateAddArrayChild, generateUpdateArrayChild, generateRemoveArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import cookie from 'cookie_js'
import { config } from '@/config'
import { format } from '@/utils/format'
import { fixProduct } from '@/service/upgradeService'

let cartPromise = null

export default {
	namespaced: true,
	state: {
		token: "",
		qrtoken: "",
		userDetail: {
			firstName: "",
			lastName: "",
			email: "",
			subscribedToNewsletter: "",
			phoneNumber: '',
		},
		referralToken: '',
		poinzDetail: {},
		clubDetails: null,
		coupons: [],
		addresses: [],
		lastOrders: [],
		favoriteProducts: [],
		reservations: [],
	},
	actions: {
		async getUser({commit, dispatch, state}, { basketToken, accumulatorGroup = null } = {} ) {
			if (!state.token) {
				let token = cookie.get(config.LOGIN_COOKIE)
				if (token) {
					commit('setToken', {item: token})
					// HACK: we set a default header for the bearer
					service.defaultHeaders.Authorization = `Bearer ${token}`
				}
			}
			if (!state.token) {
				//throw new Error("no token, login first")
				return Promise.reject(new Error("no token, login first"))
			}
			try {
				const result = await service.me({ brand: config.BRAND, tokenValue: basketToken, accumulatorGroup })
				dispatch('readUser', result);
			} catch(err) {
				// do a logout to clear all data
				dispatch('logout')
			}
			return false
		},
		async getUserCoupons({commit, state}, { basketToken, accumulatorGroup = null } = {} ) {
			if (state.token) {
        try {
          const result = await service.accountCoupons({ brand: config.BRAND, tokenValue: basketToken, accumulatorGroup })
          const coupons = result.promotionCoupons.map(coupon => ({
          	...coupon,
          	title: coupon.title || coupon.name || coupon.code
          }))

          commit('setCoupons', { item: coupons })
        } catch(err) {
          // do nothing
        }
			}
			return false
		},
		readUser({commit}, user) {
			const userDetail = {
				firstName: user.firstName,
				lastName: user.lastName,
				email: user.email,
				subscribedToNewsletter: user.subscribedToNewsletter,
				groups: user.groups,
				phoneNumber: user.phoneNumber,
				image: user.image,
				avatar: user.avatar,
				birthday: user.birthday,
			}
			const poinzDetail = {
				count: user.poinz,
				perCard: user.poinzPerCard,
				available: user.poinzAvailable,
			}
			const clubDetails = { ...user.club };

			commit('setUserDetail', { item: userDetail })
			commit('setPoinzDetail', { item: poinzDetail })
			commit('setClubDetails', { item: clubDetails })
			commit('setReferralToken', { item: user.referralToken })
		},
		async updateUser ({state, dispatch}, userDetail) {
			const result = await service.accountUpdateMe({userDetail, token: state.token, brand: config.BRAND});
			dispatch('readUser', result);
		},
		async login({commit, dispatch, state}, {email, password, userGroup, userCoupon, brand}) {
			try {
				let result = await service.login({email, password, userGroup, userCoupon, brand})
				commit('setToken', { item: result.token })
				// HACK: Previously set() resulted in a path of /de. We need the path to be
				// the root page, because we need this cookie to access /shopmanager/restore-cart
				cookie.set(config.LOGIN_COOKIE, result.token, {path: '/'})
				// HACK: we set a default header for the bearer
				service.defaultHeaders.Authorization = `Bearer ${result.token}`
				return result;
			} catch(err) {
				throw err
			}
		},
		async logout({commit, dispatch, state}, { preserveStore = false } = { preserveStore: false }) {
			commit('setToken', { item: "" })
			delete service.defaultHeaders.Authorization
			cookie.remove(config.LOGIN_COOKIE)
			// HOTFIX: this is a fallback for unknown reason
			cookie.removeSpecific(config.LOGIN_COOKIE, { path: '/' })

			// HACK: we unset header for the bearer
			if (!preserveStore) {
				delete service.defaultHeaders.Authorization
				state.userDetail = {}
				state.token = ""
				state.qrtoken = ""
				state.addresses = []
				state.lastOrders = []
			}
		},
		async register({ commit, dispatch, state }, { email, password, firstName, lastName, phoneNumber, subscribedToNewsletter, checkTerms, brand, userGroup, userCoupon, registerConfirmUrl }) {
			try {
				return await service.accountRegister({ email, password, firstName, lastName, phoneNumber, subscribedToNewsletter, checkTerms, brand, userGroup, userCoupon, registerConfirmUrl })
			} catch(err) {
				throw err
			}
		},
		async registerConfirm({ commit, dispatch, state }, { token }) {
			try {
				return await service.accountRegisterConfirm({ token, brand: config.BRAND })
			} catch(err) {
				throw err
			}
		},
		async loadLastOrders({commit, dispatch, state}, { channel = null, shippingCode = null, limit = 10, accumulatorGroup = null } = {} ) {
			try {
				let result = await service.accountOrders({ token: state.token, accumulatorGroup, channel, shippingCode, limit })
				let simpleLastOrders = result.reduce((p, c) => {
					if (true) {
						let order = {
							tokenValue: c.tokenValue,
							number: c.number,
							total: c.totals.total,
							channel: c.channel,
							channelName: c.channelName,
							shipmentCode: c.shipments[0]
								? c.shipments[0].method.code
								: "unknown",
							deliveryTime: c.deliveryTime,
							checkoutCompletedAt: c.checkoutCompletedAt,
							itemsLine: c.items
								.reduce((p, item) => {
									if (true) {
										//TODO: check for additional products
										p.push(`${item.quantity}x ${item.product.name}`)
									}
									return p
								}, [])
								.join(", ")
						}
						p.push(order)
					}

					return p
				}, [])

				commit('setLastOrders', {item: simpleLastOrders })

			} catch(err) {
				//TODO: we will handle this later
			}
		},
		async loadFavoriteProducts({ commit, dispatch, state, rootState }, { accumulatorGroup = null } = {}) {
			const channel = rootState.cart.serverData ? rootState.cart.serverData.channel.code : null
			const cartToken = rootState.cart.serverData ? rootState.cart.basketToken : null
			const result = await service.accountFavoriteProducts({ token: state.token, channel, cartToken, accumulatorGroup })

			let productList = result.items.reduce((p, c) => {
				if (!c.variants || !c.variants.length) {
					return p;
				}
				let item = fixProduct(c);
				p.push(item)
				return p
			}, []) || []

			commit('setFavoriteProdcuts', { item: productList })
			return result
		},
		async requestPasswordReset({commit, dispatch, state}, { email }) {
			let result = await service.accountRequestPasswordReset({ email, passwordResetUrl: config.PASSWORD_RESET_URL, brand: config.BRAND })
			return result
		},
		async resetPassword({ state, getters }, { current, password, confirm, token }) {
			if (getters.isLoggedIn) {
				let result = await service.accountChangePassword({ current, password, confirm, token: state.token })
				return result
			}
			let result = await service.accountResetPassword({ password, confirm, token, brand: config.BRAND })
			return result
		},
		async loadAddresses({ commit, dispatch, state}, { accumulatorGroup = null } = {}) {
			// let result = await service.accountAddresses({ token: state.token })
			try {
				let result = await service.accountLastAddress({ token: state.token, brand: config.BRAND, accumulatorGroup })
				commit('setAddresses', { item: [result] })
			}
			catch(err) {
				// most likely there is no last address
			}
		},
		async updateAddress({ commit, dispatch, state}, { userAddress, accumulatorGroup = null } = {}) {
			try {
				userAddress.brand = config.BRAND;
				let result = await service.accountUpdateAddress({ userAddress, token: state.token, accumulatorGroup })
				commit('setAddresses', { item: [result] })
			}
			catch(err) {
				throw err;
			}
		},
		async poinzRegister({ commit, dispatch, state }, { birthday, gender, accumulatorGroup = null } = {}) {
			try {
				let result = await service.accountPoinzRegister({ brand: config.BRAND, birthday, gender, token: state.token, accumulatorGroup })
			} catch(err) {
				throw err
			}
		},
		async poinzRedeem({ commit, dispatch, state}, { accumulatorGroup = null } = {}) {
			try {
				let result = await service.accountPoinzRedeem({ brand: config.BRAND, token: state.token, accumulatorGroup })
			} catch(err) {
				throw err
			}
		},
		async loadQRToken({ commit, state }) {
			try {
				let result = await service.accountGetQRToken({ token: state.token })
				commit('setQRToken', { item: result.token })
			} catch (err) {
				throw err
			}
		},
		async loadReservations({ commit, state }, { accumulatorGroup = null } = {}) {
			try {
				let result = await service.reservationList({ brand: config.BRAND, token: state.token, accumulatorGroup })
				commit('setReservations', { item: result })
			} catch (err) {
				// do nothing ¯\_(ツ)_/¯
			}
		},
		async delete({ commit, dispatch, state }) {
			try {
				await service.accountDelete({ token: state.token });
				await dispatch('logout');
				await dispatch('redirect', { name: 'delete-after' }, { root: true})
			} catch(err) {
				throw err
			}
		},
	},
	getters: {
		accountUserDetail(state) {
			return state.userDetail
				? state.userDetail
				: {}
		},
		isLoggedIn(state) {
			//TODO: currently simple check for username
			return state.userDetail && state.userDetail.email
		},
		lastOrders(state) {
			return state.lastOrders.map(order => {
				return {
					...order,
					url: `${config.SHOPMANAGER_ENDPOINT}/order-confirmation/${order.tokenValue}`
				}
			})
		},
		favoriteProducts(state) {
			return state.favoriteProducts
		},
		accountToken(state) {
			return state.token
		},
		accountLastAddress(state) {
			// return last address
			return state.addresses.slice(-1)[0]
		},
		accountPoinzDetail(state) {
			return state.poinzDetail ?
				state.poinzDetail
				: {
					count: 0,
					perCard: 0,
					available: false,
				}
		},
		accountPoinzCount(state) {
			return state.poinzDetail ?
				state.poinzDetail.count
				: 0
		},
		accountCoupons(state) {
			return state.coupons.map(c => ({
        ...c,
        validity: c.rules?.map(r => r.description).filter(r => r.trim()).join(', ')
      }))
		},
		accountQrToken(state) {
			return state.qrtoken
		},
		accountQrTokenPrefixed(state) {
			return config.ACCOUNT_QR_PREFIX + state.qrtoken
		},
		accountReferralUrl(state) {
			return state.referralToken
				? format(config.REFERRAL_URL, {token: state.referralToken})
				: null;
		},
		accountReservations(state) {
			return state.reservations
				.sort((a, b) => b.startSec - a.startSec)
				.map(reservation => {
					return {
						...reservation,
						// TODO: define a time frame where a reservation is still editable
						editable: reservation.status !== 'canceled' && reservation.cancelDeadlineAt > Math.ceil(Date.now() / 1000),
						canceled: reservation.status === 'canceled',
					}
				});
		},
		accountClubDetail(state) {
			const club = state.clubDetails;

			if (club && Object.keys(club).length) {
				let pointsToNext = 0;
				let progress = 100;

				if (
					club.tier.tier < club.nextTier.tier &&
					club.nextTier.start > club.lifeTimePoints
				) {
					pointsToNext = club.nextTier.start - club.lifeTimePoints;
				}

				if (club.tier.end) {
					progress = Math.min(Math.max(Math.round(100 / (club.tier.end - club.tier.start) * (club.lifeTimePoints - club.tier.start)), 0), 100);
				}

				return {
					...club,
					progress,
					pointsToNext,
				}
			}

			return null
		},
		accountHasAvatar(state) {
			return !!state.userDetails?.avatar;
		},
		accountHasMemberCard(state) {
			return !!state.clubDetails?.memberCard;
		},
		accountShowMemberCard(state) {
			return state.clubDetails?.showClubInfo;
		},
	},
	mutations: {
		setToken: generateSetChild("token"),
		setUserDetail: generateSetChild("userDetail"),
		setPoinzDetail: generateSetChild("poinzDetail"),
		setClubDetails: generateSetChild('clubDetails'),
		setCoupons: generateSetChild("coupons"),
		setLastOrders: generateSetChild("lastOrders"),
		setFavoriteProdcuts: generateSetChild("favoriteProducts"),
		setAddresses: generateSetChild("addresses"),
		setReferralToken: generateSetChild("referralToken"),
		setQRToken: generateSetChild("qrtoken"),
		setReservations: generateSetChild("reservations"),
	}
}
